export default __webpack_public_path__ + "static/media/drawkit-nature-man-colour.9f31958f.svg";